
<template>
  <!--活动管理-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="id"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
      rowOptLen = 4
    >
      <template slot="opt_img" slot-scope="{row}">
        <img style="height: 44px;width:auto" :src="row.img" alt="">
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="activityColor[row.status]"></span>
          <span>{{ row.statusDesc }}</span>
        </div>
      </template>
    </x-tabula>
  </div>
</template>

<script>
const activityType = [
  { value: 1, label: '活动 ' },
  { value: 2, label: '团购' }
];
export default {
  name: 'platActivityManage',
  data () {
    return {
      activityColor: [
        'success-bg',
        'info-bg',
        'info-bg',
        'info-bg',
        'info-bg'
      ],
      searchList: [
        { props: ['title'], placeholder: '活动标题', options: [], inputType: 'input' },
        { props: ['type'], placeholder: '类型', options: activityType, inputType: 'select' },
        { props: ['closeDate'], placeholder: ['起始时间', '截止时间'], options: [], inputType: 'datePick' },
        { props: ['nickName'], placeholder: '发布人', options: [], inputType: 'input' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '详情', handle: (row) => this.toDetail(row.activityId), permi: ['community:activity:query'] },
        { text: '报名名单', handle: (row) => this.toapplylist(row.activityId), permi: ['community:activity:applylist'] },
        {
          text: '',
          handle: (row) => this.toFreeze(row),
          rowOptDisHandle: row => this.optBtnDisable(row),
          customRender: true,
          rowOptText: row => row.isFrozenShow == 0 ? '' : (row.isFrozenShow == 1 ? '冻结' : '解冻'),
          permi: ['community:activity:frozen']
        },
        {
          text: '',
          handle: (row) => this.toSettlementDetails(row.activityId),
          customRender: true,
          rowOptText: row => row.settleStatus == 1 ? '结算详情' : '',
          permi: ['community:activity:settlementDetail']
        }

      ],
      columns: [
        { title: '活动ID', dataIndex: 'activityId', align: '', width: '' },
        { title: '封面图', dataIndex: 'img', align: '', width: '', scopedSlots: { customRender: 'img' } },
        { title: '活动标题', dataIndex: 'title', align: '', width: '' },
        { title: '类型', dataIndex: 'typeDesc', align: '', width: '' },
        { title: '发布人', dataIndex: 'nickName', align: '', width: '' },
        { title: '活动开始时间', dataIndex: 'startTime', align: '', width: '' },
        { title: '活动结束时间', dataIndex: 'endTime', align: '', width: '' },
        { title: '截止时间', dataIndex: 'closeTime', align: '', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: '', width: '', scopedSlots: { customRender: 'status' } },
        { title: '结算状态', dataIndex: 'settleStatusDesc', align: '', width: '' },
        { title: '操作', dataIndex: 'action', align: '', width: '', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [],
      searchParams: {
        title: undefined,
        type: undefined,
        closeDate: undefined,
        nickName: undefined
      },
      listApi: {
        url: '/activity/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addActivity',
        addTitle: '新建活动',
        editTitle: '编辑活动'
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
  },
  methods: {
    toFreeze (row) {
      if (row.isFrozenShow == 1) { // 冻结
        this.$post({
          url: `/activity/frozen/${row.activityId}`
        }).then(({ data }) => {
          this.$message.success('冻结成功');
          this.$refs.table.getTableList();
        });
      } else if (row.isFrozenShow == 2) { // 解冻
        this.$post({
          url: `/activity/thaw/${row.activityId}`
        }).then(({ data }) => {
          this.$message.success('解冻成功');
          this.$refs.table.getTableList();
        });
      } else {
        console.error('未知操作:' + row.isFrozenShow);
      }
    },
    optBtnDisable (row) {
      if (row.isFrozenShow == 0) {
        return true;
      }
    },
    toapplylist (activityId) {
      this.$router.push({
        name: 'ActivityApplyList',
        query: { activityId, ...this.breadParam(this) }
      });
    },
    // 结算详情
    toSettlementDetails (id) {
      this.$router.push({
        name: 'activitySettlementDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    // 详情
    toDetail (id) {
      this.$router.push({
        name: 'activityDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    getSelect () {
    },
    /** 查看订单 */
    showOrder (row) {
      this.$router.push({
        name: 'activityOrder',
        query: { id: row.id, activityTitle: row.title, time: row.activityTime }
      });
    },
    /** 切换状态 */
    changeStatus (row) {
      this.$put({
        url: `/pm/lottery/changeStatus/${row.id}`,
        params: { status: row.status === 1 ? 0 : 1 } // 0停用，1启用
      }).then(({ data }) => {
        this.$message.success('切换成功');
        this.$refs.table.getTableList();
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<!-- <style scoped>
  ::v-deep layout-content{
    padding:0;
    background: white ;
  }
</style>
<style>
  ::v-deep .layout-content{
    padding:0;
    background: white ;
  } -->
</style>
